import { Injectable } from '@angular/core';
import { iBisEditService, iBisFileService, iBisLanguageService } from '@dohu/ibis-common';
import { iBisEntityService } from '@dohu/ibis-entity';
import { alert } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { QuotationService } from '../../quotation.service';

@Injectable({
  providedIn: 'root'
})
export class AddClarificationService extends iBisEditService {
  files: any[] = [];
  constructor(lg: iBisLanguageService, private entity: iBisEntityService,
    private qs: QuotationService) {
    super(lg);
    this.title = this.L('CLARIFICATION');
    this.files = [];
  }
  createDefault() {
    this.files = [];
    return {};
  }
  getById(_id: string, _serverUrl?: string | undefined): Promise<any> {
    return Promise.reject('Method not implemented.');
  }
  onRemove(_id: string): Promise<void> {
    return Promise.reject('Method not implemented.');
  }
  onSaveEv(_serverUrl?: string | undefined): Promise<any> {
    return this.entity.execute('AddClarification', this.model).then(entityId => {
      notify(this.L('CLARIFICATION_ADDED'), 'success', 2000);
      const uploads = this.files.map((fileItem: any) =>
        new Promise<void>((res) => {
          this.qs.uploadFile(entityId, fileItem.name, fileItem).subscribe({
            next: () => { notify(this.L('FILE_UPLOADED'), 'success', 2000); },
            complete: res,
            error: () => { notify(this.L('UPLOAD_ERROR'), 'error', 2000); res(); }
          });
        })
      );
      return Promise.all(uploads);
    });
  }
  reset(): void {
    this.model = this.createDefault();
  }

  override popupInit(event: any): void {
    super.popupInit(event);
    event.component.beginUpdate();
    const ti = event.component.option('toolbarItems');
    ti[0].options.icon = 'email';
    ti[0].options.text = this.L('SEND');
    ti.unshift({
      toolbar: 'bottom',
      widget: 'dxButton',
      options: {
        icon: 'upload',
        type: 'default',
        text: this.L('UPLOAD_FILE'),
        onClick: (eb: any) => {
          alert(this.L('NO_COMMERCIAL_INFO_ALERT'), this.L('FILES_ALERT')).then(() => {
            const input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.style.display = 'none';
            document.body.appendChild(input);
            input.addEventListener('change', (e) => {
              if (input && input.files) {
                const file: File = input.files[0];
                if (Math.floor(file.size / 1048576) >= 100) {
                  alert("Dimensiunea maxima admisa este de 100MB.", "Alerta");
                  document.body.removeChild(input);
                  return;
                }
                this.files.push(file);
              }
              document.body.removeChild(input);
            });
            input.click();
          });
        }
      },
      location: 'before'
    })
    event.component.option('toolbarItems', ti);
    event.component.endUpdate();
  }

}
